import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.75 4.875V4.125C10.75 4.05625 10.6938 4 10.625 4H4.625C4.55625 4 4.5 4.05625 4.5 4.125V4.875C4.5 4.94375 4.55625 5 4.625 5H10.625C10.6938 5 10.75 4.94375 10.75 4.875ZM4.625 6.25C4.55625 6.25 4.5 6.30625 4.5 6.375V7.125C4.5 7.19375 4.55625 7.25 4.625 7.25H7.5C7.56875 7.25 7.625 7.19375 7.625 7.125V6.375C7.625 6.30625 7.56875 6.25 7.5 6.25H4.625ZM6.875 13.3125H3.25V2.3125H12V7.6875C12 7.75625 12.0562 7.8125 12.125 7.8125H13C13.0688 7.8125 13.125 7.75625 13.125 7.6875V1.6875C13.125 1.41094 12.9016 1.1875 12.625 1.1875H2.625C2.34844 1.1875 2.125 1.41094 2.125 1.6875V13.9375C2.125 14.2141 2.34844 14.4375 2.625 14.4375H6.875C6.94375 14.4375 7 14.3813 7 14.3125V13.4375C7 13.3687 6.94375 13.3125 6.875 13.3125ZM13.8391 14.1172L12.3813 12.6594C12.7297 12.1984 12.9375 11.6234 12.9375 11C12.9375 9.48125 11.7062 8.25 10.1875 8.25C8.66875 8.25 7.4375 9.48125 7.4375 11C7.4375 12.5187 8.66875 13.75 10.1875 13.75C10.7469 13.75 11.2656 13.5828 11.7 13.2969L13.1797 14.7766C13.2047 14.8016 13.2359 14.8125 13.2672 14.8125C13.2984 14.8125 13.3313 14.8 13.3547 14.7766L13.8391 14.2922C13.8506 14.2807 13.8597 14.2671 13.866 14.2521C13.8722 14.2371 13.8754 14.2209 13.8754 14.2047C13.8754 14.1884 13.8722 14.1723 13.866 14.1573C13.8597 14.1423 13.8506 14.1287 13.8391 14.1172V14.1172ZM10.1875 12.75C9.22031 12.75 8.4375 11.9672 8.4375 11C8.4375 10.0328 9.22031 9.25 10.1875 9.25C11.1547 9.25 11.9375 10.0328 11.9375 11C11.9375 11.9672 11.1547 12.75 10.1875 12.75Z",
  fill: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'FileSearchIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "file-search",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})